import {Component, inject, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { SharedModule } from '../../../../core/modules/shared.module';
import { MaterialModule } from '../../../../core/modules/material.module';
import { PagesContainerComponent } from '../../pages-container/pages-container.component';
import { AdditionalFrontUserInfoFormDialogComponent } from './setting-form/setting-form.component';
import {AdditionalFrontUserInfoService} from '../../../../core/services/additionalFrontUserInfo.service';

@Component({
  selector: 'additional-front-user-info',
  templateUrl: './additionalFrontUserInfo.component.html',
  styleUrls: ['./additionalFrontUserInfo.component.scss'],
  imports: [SharedModule, MaterialModule, PagesContainerComponent]
})
export class AdditionalFrontUserInfoComponent implements OnInit {
  additionalService = inject(AdditionalFrontUserInfoService);
  translate = inject(TranslateService);
  dataSource: any[] = [];
  displayedColumns: string[] = ['title', 'active', 'showOnTable', 'columnName'];
  dialogRef: any;

  constructor(
    public dialog: MatDialog,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.additionalService.getAllAdditionalFrontUserInfo().subscribe({
      next: response => {
        this.dataSource = response;
      }
    });
  }

  newType(): void {
    this.dialogRef = this.dialog.open(AdditionalFrontUserInfoFormDialogComponent, {
      panelClass: 'contact-form-dialog',
      width: '400px',
      data: {
        action: 'new'
      }
    });

    this.dialogRef.afterClosed().subscribe((response: any) => {
      if (!response) {
        return;
      }
      const data = response.value ? response.value : response;
      if (data && data.title) {
        this.additionalService.addAdditionalFrontUserInfo(data).subscribe({
          next: () => {
            this.snackBar.open(this.translate.instant('additionalFrontUserInfo.add_success'), '', { duration: 2500 });
            this.getData();
          },
          error: () => {
            this.snackBar.open(this.translate.instant('additionalFrontUserInfo.add_error'), '', { duration: 2500 });
          }
        });
      }
    });
  }

  editType(item: any): void {
    this.dialogRef = this.dialog.open(AdditionalFrontUserInfoFormDialogComponent, {
      panelClass: 'contact-form-dialog',
      width: '400px',
      data: {
        type: item,
        item: item,
        action: 'edit'
      }
    });

    this.dialogRef.afterClosed().subscribe((response: any) => {
      if (!response) {
        return;
      }

      if (Array.isArray(response)) {
        const actionType: string = response[0];
        const formValue = response[1]?.value || response[1];

        if (actionType === 'save') {
          const updatedItem = { ...item, ...formValue, id: item.id };
          this.additionalService.addAdditionalFrontUserInfo(updatedItem).subscribe({
            next: () => {
              this.snackBar.open(this.translate.instant('additionalFrontUserInfo.update_success'), '', { duration: 2500 });
              this.getData();
            },
            error: () => {
              this.snackBar.open(this.translate.instant('additionalFrontUserInfo.update_error'), '', { duration: 2500 });
            }
          });
        } else if (actionType === 'delete') {
          this.additionalService.deleteAdditionalFrontUserInfo(item.id).subscribe({
            next: () => {
              this.snackBar.open(this.translate.instant('additionalFrontUserInfo.delete_success'), '', { duration: 2500 });
              this.getData();
            },
            error: () => {
              this.snackBar.open(this.translate.instant('additionalFrontUserInfo.delete_error'), '', { duration: 2500 });
            }
          });
        }
      } else {
        const formValue = response.value || response;
        const updatedItem = { ...item, ...formValue, id: item.id };
        this.additionalService.addAdditionalFrontUserInfo(updatedItem).subscribe({
          next: () => {
            this.snackBar.open(this.translate.instant('additionalFrontUserInfo.update_success'), '', { duration: 2500 });
            this.getData();
          },
          error: () => {
            this.snackBar.open(this.translate.instant('additionalFrontUserInfo.update_error'), '', { duration: 2500 });
          }
        });
      }
    });
  }
}
